module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/homeofthebrave.2671b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/homeofthebrave.jpg
// module id = DiuR
// module chunks = 0